/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_StartInputs */

const cs_property_legal_start = /** @type {(inputs: Property_Legal_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od`)
};

const en_property_legal_start = /** @type {(inputs: Property_Legal_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date`)
};

/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Property_Legal_StartInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_start = /** @type {((inputs?: Property_Legal_StartInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_StartInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_start(inputs)
	return cs_property_legal_start(inputs)
});